import styled from 'styled-components';
import {
  ContentBox,
  RowSpaceTextBox
} from '../../styles/chime-react/CommonStyles';

export const StyledMaintenanceContentBox = styled(ContentBox)`
  padding: 1.5rem 1rem;

  ${({ theme }) => theme.mediaQueries.min.md} {
    padding: 2.5rem;
  }
`;

export const StyledMaintenanceRowSpaceBox = styled(RowSpaceTextBox)`
  margin-top: 1.5rem;

  ${({ theme }) => theme.mediaQueries.min.md} {
    padding: 2rem;
  }
`;
